import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

import ToggleListItemContentNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          toggle_block_content(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: ToggleListItemContentNodeView,
            });
          },
        },
      },
    }),
  ];
}

export default plugins;
